import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function TechCTA() {
  const { lang } = useLanguage();
  const isEn = lang === 'en';
  const isJa = lang === 'ja';

  const checkItems = isEn
    ? ['Provide existing raw material types and sources', 'Describe current formulation conditions', 'Specify processing method (injection / extrusion / compounding)', 'Define target property specifications']
    : isJa
    ? ['既存の原料種類と供給元を提供', '現在の配合条件を説明', '加工方法を指定（射出・押出・造粒）', '目標物性仕様を設定']
    : ['提供現有原料種類與來源', '說明目前配方條件', '描述加工方式（射出 / 押出 / 造粒）', '設定目標物性規格'];

  const heading = isEn
    ? <>Want to Evaluate Whether Your Recycled Materials<br className="hidden sm:block" />Are Suitable for PQernel® Integration?</>
    : isJa
    ? <>再生材料がPQernel®導入に<br className="hidden sm:block" />適しているか評価したいですか？</>
    : <>想評估您的再生料是否<br className="hidden sm:block" />適合導入 PQernel®？</>;

  const body = isEn
    ? 'Provide your existing raw materials, formulation conditions, processing methods, and target properties. PolyQ can assist with a preliminary assessment and plan the most suitable PQernel® application approach for you.'
    : isJa
    ? '既存の原料・配合条件・加工方法・目標物性をご提供ください。聚量応用材料が初期評価を支援し、最適なPQernel®応用プランを設計します。'
    : '提供現有原料、配方條件、加工方式與目標物性，聚量可協助初步判斷導入方向，為您規劃最適合的 PQernel® 應用方案。';

  const ctaLabel = isEn ? 'Schedule a Technical Consultation' : isJa ? '技術相談を予約する' : '預約技術諮詢';
  const checklistTitle = isEn ? 'Please Prepare Before Consultation' : isJa ? 'ご相談前にご準備ください' : '諮詢前請準備';
  const responseNote = isEn
    ? <>Initial assessment typically responded within <strong className="text-neutral-dark">3 business days</strong></>
    : isJa
    ? <>初期評価は通常<strong className="text-neutral-dark">3営業日以内</strong>に回答します</>
    : <>初步評估通常於 <strong className="text-neutral-dark">3 個工作天</strong>內回覆</>;

  return (
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F0FAF6] via-[#EBF4FF] to-[#F5F8FB]" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-50 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.14) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] opacity-35 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.10) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mb-6">
              <i className="ri-flask-line text-white text-2xl"></i>
            </div>
            <h2 className="font-bold text-neutral-dark mb-5" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}>{heading}</h2>
            <p className="text-neutral-mid mb-8" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>{body}</p>
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-schedule-line"></i>{ctaLabel}
            </Link>
          </div>
          <div className="bg-white rounded-2xl border border-neutral-border p-7" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.07)' }}>
            <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-5">{checklistTitle}</p>
            <ul className="space-y-4">
              {checkItems.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-green-light flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-green text-sm"></i>
                  </div>
                  <span className="text-neutral-dark text-[1.0625rem] leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 pt-5 border-t border-neutral-border flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-brand-green-light flex-shrink-0">
                <i className="ri-time-line text-brand-green text-xl"></i>
              </div>
              <p className="text-neutral-mid text-[1rem] leading-relaxed">{responseNote}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
